import React, { useEffect } from 'react';
import classNames from 'classnames';

interface iHeaderCollapsibleProps {
  title: string;
  children: React.ReactNode;
  titleClassname?: string;
  childrenClassname?: string;
}

export const HeaderCollapsible = (props: iHeaderCollapsibleProps) => {
  const { children, titleClassname = '', childrenClassname = '' } = props;
  const [originalHeight, setOriginalHeight] = React.useState(0);
  const [isOpen, setIsOpen] = React.useState(false);
  const childrenRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    const height = childrenRef.current?.getBoundingClientRect().height || 0;
    setOriginalHeight(height);
  }, [isOpen, childrenRef]);

  return (
    <>
      <button
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        className={classNames(
          'm-0 p-0 bg-transparent text-brown-prime uppercase flex items-center cursor-pointer text-14px font-hurmegeometric-sans font-[600]',
          titleClassname
        )}
      >
        <span className="w-6 text-[20px] font-normal -ml-[5px]">{isOpen ? '-' : '+'}</span>
        <span>{props.title}</span>
      </button>
      <div
        className={classNames(
          'relative overflow-y-clip transition-[max-height]',
          {
            hidden: !isOpen,
            block: isOpen,
          },
          childrenClassname
        )}
        style={{
          height: '100%',
          maxHeight: !isOpen ? `${0}px` : `${originalHeight}px`,
        }}
      >
        <span ref={childrenRef}>{children}</span>
      </div>
    </>
  );
};
